import React from 'react';
import Items from '../Items';
import { LessonBlock } from '../types';

// Like ContentCard, the visible heading is setupTitle at card-title size, and
// `block.title` stays unrendered.
//
// The prototype's practice steps arrive as isBullet items (all 181 of them), so
// the isStep branch inside stepsItems never fires today — Items handles both.
export default function PracticeCard({ block }: { block: LessonBlock }) {
  return (
    <div className="pc-lesson-practice">
      {block.setupTitle && <h2 className="pc-lesson-card-title">{block.setupTitle}</h2>}
      <Items items={block.setupItems || []} />
      {block.hasObjective && (
        <div className="pc-lesson-practice-objective">
          <span className="pc-lesson-practice-objective-icon" aria-hidden="true">flag</span>
          <div>
            <span className="pc-lesson-practice-objective-label">Objective</span>
            <p className="pc-lesson-p">{block.objectiveText}</p>
          </div>
        </div>
      )}
      {block.hasSteps && (
        <>
          {block.hasStepsTitle && (
            <h3 className="pc-lesson-practice-steps-title">{block.stepsTitle}</h3>
          )}
          <Items items={block.stepsItems || []} />
        </>
      )}
    </div>
  );
}
